import { createAsyncThunk } from '@reduxjs/toolkit';

import { fetchWrapper } from '../../../../../helpers';
import { INTAKE_QUESTIONNAIRES_API_BASE } from '../../constants';

import type { ITherapy } from '../../../../../pages/common';
import type {
  CreateIntakeTherapyPayload,
  DeleteAllIntakeTherapiesPayload,
  DeleteIntakeTherapyPayload,
  SetIntakeHasNoTherapiesPayload,
  UpdateIntakeTherapyPayload,
} from './types';

export function createIntakeTherapyThunks() {
  return {
    createIntakeTherapy: createIntakeTherapy(),
    updateIntakeTherapy: updateIntakeTherapy(),
    deleteIntakeTherapy: deleteIntakeTherapy(),
    deleteAllIntakeTherapies: deleteAllIntakeTherapies(),
    setIntakeHasNoTherapies: setIntakeHasNoTherapies(),
  };
}

function createIntakeTherapy() {
  return createAsyncThunk<ITherapy, CreateIntakeTherapyPayload>(
    'intakeQuestionnaire/createIntakeTherapy',
    async ({ intakeQuestionnaireId, data, getAccessTokenSilently }) =>
      fetchWrapper.post(
        {
          url: `${INTAKE_QUESTIONNAIRES_API_BASE}/${intakeQuestionnaireId}/therapy`,
          getAccessTokenSilently,
        },
        data,
      ),
  );
}

function updateIntakeTherapy() {
  return createAsyncThunk<ITherapy, UpdateIntakeTherapyPayload>(
    'intakeQuestionnaire/updateIntakeTherapy',
    async ({ intakeQuestionnaireId, therapyId, data, getAccessTokenSilently }) =>
      fetchWrapper.patch(
        {
          url: `${INTAKE_QUESTIONNAIRES_API_BASE}/${intakeQuestionnaireId}/therapy/${therapyId}`,
          getAccessTokenSilently,
        },
        data,
      ),
  );
}

function deleteIntakeTherapy() {
  return createAsyncThunk<void, DeleteIntakeTherapyPayload>(
    'intakeQuestionnaire/deleteIntakeTherapy',
    async ({ intakeQuestionnaireId, therapyId, getAccessTokenSilently }) => {
      await fetchWrapper.delete({
        url: `${INTAKE_QUESTIONNAIRES_API_BASE}/${intakeQuestionnaireId}/therapy/${therapyId}`,
        getAccessTokenSilently,
      });
    },
  );
}

function deleteAllIntakeTherapies() {
  return createAsyncThunk<void, DeleteAllIntakeTherapiesPayload>(
    'intakeQuestionnaire/deleteAllIntakeTherapies',
    async ({ intakeQuestionnaireId, getAccessTokenSilently }) => {
      await fetchWrapper.delete({
        url: `${INTAKE_QUESTIONNAIRES_API_BASE}/${intakeQuestionnaireId}/therapy/all`,
        getAccessTokenSilently,
      });
    },
  );
}

function setIntakeHasNoTherapies() {
  return createAsyncThunk<void, SetIntakeHasNoTherapiesPayload>(
    'intakeQuestionnaire/setIntakeHasNoTherapies',
    async ({ intakeQuestionnaireId, hasNoTherapies, getAccessTokenSilently }) => {
      await fetchWrapper.patch(
        {
          url: `${INTAKE_QUESTIONNAIRES_API_BASE}/${intakeQuestionnaireId}`,
          getAccessTokenSilently,
        },
        { has_no_therapies: hasNoTherapies },
      );
    },
  );
}
